import { Box, Flex, HStack, Stack, Text, useDisclosure } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import { RiArrowRightSLine } from 'react-icons/ri';

interface IOwnProps {
  icon?: ReactNode;
  label?: string;
  value?: string | ReactNode;
  acceptTag?: boolean;
  hiddenColon?: boolean;
}

export const LabelWithValueBreakArrow: React.FC<IOwnProps> = ({ label, value, icon }) => {
  return (
    <HStack>
      {icon && <Box w="17px">{icon}</Box>}
      <Stack gap={0}>
        <Text as="span" mr={1} fontWeight="semibold">
          {label}
        </Text>
        <Flex>
          <Box
            ml={1}
            borderLeft="1px solid"
            mt="-2px"
            mr={2}
            borderBottom="1px solid"
            h="12px"
            w="12px"
            position="relative"
          >
            <Box position="absolute" right="-9px" bottom="-9px">
              <RiArrowRightSLine size={17} />
            </Box>
          </Box>
          <Text>{value}</Text>
        </Flex>
      </Stack>
    </HStack>
  );
};

const LabelWithValueMobilePage: React.FC<IOwnProps> = ({ label, value, acceptTag, icon, hiddenColon }) => {
  const seeMore = useDisclosure();

  return (
    <Flex direction={acceptTag ? 'column' : 'row'} wrap="wrap" gap={1} w="100%" minW={0}>
      {icon && (
        <Box mr={1} w="17px">
          {icon}
        </Box>
      )}
      <Text fontWeight="semibold" color="black" minW={0} maxW="100%" overflowWrap="anywhere" wordBreak="break-word">
        {label && label}
        {label && !hiddenColon && ':'}
        {(value && typeof value === 'string' && (
          <Text
            as="span"
            {...(acceptTag && {
              lineHeight: 'tall',
              mt: -1,
            })}
            ml={label && 1}
            color="gray.800"
            fontWeight="initial"
            overflowWrap="anywhere"
            wordBreak="break-word"
          >
            {acceptTag ? (
              <>
                <Text
                  as="span"
                  dangerouslySetInnerHTML={{
                    __html:
                      value.length > 200
                        ? `${value.substring(0, seeMore.isOpen ? value.length : 200)}${seeMore.isOpen ? '' : '...'}`
                        : value,
                  }}
                />
                {value.length > 200 && (
                  <Text
                    whiteSpace="nowrap"
                    as="span"
                    onClick={seeMore.onToggle}
                    ml={1}
                    cursor="pointer"
                    fontSize="sm"
                    color="blue.400"
                    textDecoration="underline"
                  >
                    ver {seeMore.isOpen ? 'menos' : 'mais'}
                  </Text>
                )}
              </>
            ) : (
              value || '--'
            )}
          </Text>
        )) ||
          value}
      </Text>
    </Flex>
  );
};

export default LabelWithValueMobilePage;
